<div class="information-container">
  <ion-button class="button transparent close-modal" [ngClass]="font?.size" (click)="clickCloseButton()">
    <ion-icon class="icon" name="close"></ion-icon>
  </ion-button>
  <div class="title" [ngClass]="font?.size" [innerHTML]="data?.title"></div>
  <div class="paragraph" [ngClass]="font?.size" [innerHTML]="data?.description"></div>
  <ion-button class="button primary action" (click)="goToUrl()" [ngClass]="font?.size">{{ data?.button.name }}</ion-button>
</div>
